module.exports = __webpack_public_path__ + "img/more.441a70a7.png";